import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../shared/services/auth.service';
import { ExternalSystemLinkModel } from '../shared/models/navigation.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class HomeComponent implements OnInit, OnDestroy {
  externalSystems: ExternalSystemLinkModel[];
  externalSystemsSubs: Subscription;
  failedUrl = environment.imperia.tmsFailedUrl;
  selectedComponent = 'email';
  isLoading = false;

  constructor(
    private readonly authService: AuthService
  ) {}

  ngOnInit(): void {
    this.getUsefulLinks();
  }

  private getUsefulLinks(): void {
    this.externalSystems = this.authService.getExternalSystemLinks();
  }

  ngOnDestroy(): void {
    if (this.externalSystemsSubs) {
      this.externalSystemsSubs.unsubscribe();
    }
  }

  externalSystemUrl(
    url: string,
    id: string,
    password: string,
    type: string
  ): string {
    let newUrl;
    switch (type) {
      case 'MG':
        newUrl = `${url}?UserId=${id}&Password=${password}&failedurl=${this.failedUrl}`;
        break;
      default:
        newUrl = url;
    }
    return newUrl;
  }
}
